import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const USER_PATH = "/user/v1";
const ROLE_PATH = "/role/v1";

// user

export const getUserApi = async (params, options = {}) => await getRequest(USER_PATH, params, options);

export const getUserByIdApi = async (params, options = {}) => await getRequest(`${USER_PATH}/${params?.id}`);

export const addUserApi = async (body) => await postRequest(USER_PATH, body);

export const updateUserApi = async (body) =>
  await putRequest(`${USER_PATH}/${body?._id}`, body);

export const deleteUserByIdApi = async (id) =>
  await deleteRequest(`${USER_PATH}/${id}`);

export const uploadImageApi = async (body) =>
  await postRequest(`${USER_PATH}/image`, body, true);

// update role
export const updateRole = async (params, body) =>
  await putRequest(`${USER_PATH}/updateRole/${params?.id}`, body);

// update unit
export const updateUnit = async (params, body) =>
  await putRequest(`${USER_PATH}/updateUnit/${params?.id}`, body);

// role

export const getRoleApi = async (params, options = {}) => await getRequest(ROLE_PATH, params, options);
